import { DettaglioAdempimento } from "src/app/common/models/dettaglio-adempimento";

export class DettaglioAdempimentoAdapter {
  dettaglioAdempimento: DettaglioAdempimento = new DettaglioAdempimento();

  constructor(dettaglioAdempimento?: DettaglioAdempimento) {  
    this.dettaglioAdempimento.id = dettaglioAdempimento.id ? dettaglioAdempimento.id : null;
    this.dettaglioAdempimento.tipoEsito = dettaglioAdempimento.tipoEsito ? JSON.parse(JSON.stringify(dettaglioAdempimento.tipoEsito)) : null;
    this.dettaglioAdempimento.esitoDescrizione = dettaglioAdempimento.esitoDescrizione ? dettaglioAdempimento.esitoDescrizione : null;
    this.dettaglioAdempimento.numeroEsito = dettaglioAdempimento.numeroEsito ? dettaglioAdempimento.numeroEsito : null;
    this.dettaglioAdempimento.annoEsito = dettaglioAdempimento.annoEsito ? dettaglioAdempimento.annoEsito : null;
    this.dettaglioAdempimento.dataPubblicazione = dettaglioAdempimento.dataPubblicazione ? dettaglioAdempimento.dataPubblicazione : null;    
  }
}

